import React from 'react';
import PropTypes from 'prop-types';
import Input from '@blaze-react/input';
import Select from '@blaze-react/select';
import { Checkbox } from '@blaze-react/checkboxes';

const FormInput = ({
  className,
  label,
  type,
  options,
  data,
  id,
  onChange,
  privacyPolicyUrl,
  termsAndConditionsUrl,
  isRequired
}) => {
  const { value, error, validationMessage } = data;
  const inputClassName = `${className}__input${error ? ' error' : ''}${
    type === 'select' ? ' select' : ''
  } ${id}`;

  const handleOnChange = ({ value: newValue }) => {
    onChange(id, newValue);
  };

  return (
    <div className={inputClassName}>
      {type === 'checkbox' && (
        <>
          <div className="checkbox-wrapper">
            <Checkbox
              checked={value}
              name={id}
              id={id}
              data-testid={id}
              onChange={handleOnChange}
            />
            <label htmlFor={`${id}-checkbox`}>
              {!label ? (
                <>
                  The personal information you provide will be processed in line with our
                  <a href={privacyPolicyUrl}> Privacy Policy</a>. By using our website, you agree to
                  our
                  <a role="button" href={termsAndConditionsUrl}>
                    {' '}
                    Terms and Conditions
                  </a>
                  .
                </>
              ) : (
                label
              )}
            </label>
          </div>
          {error && (
            <div className="validation" data-testid="validation-message">
              <i className="material-icons">warning</i>
              {validationMessage}
            </div>
          )}
        </>
      )}
      {type === 'password' && (
        <Input
          label={label}
          onChange={handleOnChange}
          required={isRequired}
          value={value}
          type={type}
          error={error}
          validationMessage={validationMessage}
        />
      )}
      {type === 'text' && (
        <Input
          label={label}
          onChange={handleOnChange}
          required={isRequired}
          value={value}
          type={type}
          error={error}
          validationMessage={validationMessage}
        />
      )}
      {type === 'select' && (
        <Select
          key={
            options.length ? options[1][0] : id
          } /* fix for select component to reset when options */
          label={label}
          selected={value}
          name={id}
          onChange={handleOnChange}
          options={options}
          disabled={['']}
          showDefaultOption={false}
          required={isRequired}
        />
      )}
    </div>
  );
};

FormInput.propTypes = {
  className: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  data: PropTypes.object,
  options: PropTypes.array,
  isRequired: PropTypes.bool,
  type: PropTypes.string,
  privacyPolicyUrl: PropTypes.string,
  termsAndConditionsUrl: PropTypes.string
};

FormInput.defaultProps = {
  type: 'text',
  options: [],
  isRequired: false,
  privacyPolicyUrl: null,
  termsAndConditionsUrl: null,
  data: {}
};

export default FormInput;
